/* @ngInject */
function AdvancedSearchController ($rootScope, $scope, $element, $timeout, $attrs, Utils) {
  let inputEl = null
  $scope.inputValue = ''
  $scope.inputFocus = false
  $scope.filterIsOpen = false
  $scope.searchIsOpen = false
  $scope.tagSearch = ''
  $scope.searchValue = {}
  $scope.selectedTags = []
  $scope.locale = 'EN-US'
  $scope.filtersCount = 0

  const api = {
    _handleClickAway,
    _handleEventClearSearch,
    _successGetUser
  }
  this.getApi = () => api

  activate()

  function activate () {
    document.addEventListener('click', api._handleClickAway)
    $rootScope.getUser().then(api._successGetUser)

    if ($scope.value) {
      $scope.inputValue = $scope.value
    }

    $timeout(() => {
      inputEl = $attrs.$$element.find('.advanced-search__input-el')
    }, 100)
  }

  const deregisterClearSearch = $scope.$on('advancedSearch.clearSearch', api._handleEventClearSearch)

  $scope.$on('$destroy', function () {
    document.removeEventListener('click', api._handleClickAway)
    deregisterClearSearch()
  })

  function _handleClickAway (event) {
    const isSearchElement = $element[0].contains(event.target)

    if (!isSearchElement) {
      $timeout(() => {
        $scope.searchIsOpen = false
        $scope.filterIsOpen = false
        $scope.inputFocus = false
      }, 0, true)
    }
  }

  function _handleEventClearSearch () {
    $scope.onClearClick()
  }

  $scope.removeTag = (removedTag) => {
    $scope.selectedTags = $scope.selectedTags.filter(tag => removedTag.id !== tag.id)
    $scope.onDropdownSubmit()
  }

  $scope.onInputFocus = () => {
    $timeout(() => {
      $scope.filterIsOpen = false
      $scope.inputFocus = true
      $scope.searchIsOpen = true
    }, 0, true)
  }

  $scope.onInputChange = Utils.debounce(() => {
    if (!$scope.hasAdvancedSearch) {
      $scope.onDropdownSubmit()
    }
  })

  $scope.onInputKeypress = (event) => {
    if ($scope.hasAdvancedSearch) {
      const { key, keyCode } = event

      if (key === 'Enter' && keyCode === 13) {
        $scope.onDropdownSubmit()
      }
    }
  }

  $scope.onClearClick = () => {
    $scope.inputValue = ''
    $scope.tagSearch = ''
    $scope.selectedTags = []

    $scope.onDropdownSubmit()
  }

  $scope.onFilterClick = () => {
    $timeout(() => {
      $scope.filterIsOpen = !$scope.filterIsOpen
      $scope.searchIsOpen = false
    }, 0, true)
  }

  $scope.onFilterSubmit = (filter, hasPreFilters, filtersCount) => {
    $scope.onFilter(filter, hasPreFilters, filtersCount)
  }

  $scope.onFilterCount = (count) => {
    if ($scope.onCount) {
      $scope.onCount(count)
    }
  }

  $scope.onDropdownSubmit = () => {
    if ($scope.hasAdvancedSearch) {
      const tagsId = $scope?.selectedTags.map((tag) => tag?.id)
      const search = {
        tags: tagsId.length ? tagsId : null,
        searchTerm: $scope.inputValue
      }

      $scope.onSearch(search)
      $scope.searchIsOpen = false
      inputEl.blur()
      return
    }

    $scope.onSearch($scope.inputValue)
  }

  $scope.onDropdownAssetClick = (asset) => {
    $scope.searchIsOpen = false
    inputEl.blur()
    $scope.onAssetClick(asset)
  }

  function _successGetUser ({ locale }) {
    $scope.locale = locale
  }

  $scope.$on('advancedSearch.filtersCount', (event, count) => {
    $scope.filtersCount = count
  })

  $scope.$on('advancedSearch.clearAllFilters', () => {
    $scope.onClearClick()
  })

  $scope.$on('advancedSearch.onFilterSubmit', (event, filter, hasPreFilters, filtersCount) => {
    $scope.onFilterSubmit(filter, hasPreFilters, filtersCount)
  })
}

export { AdvancedSearchController }
